<template>
  <div v-if="this.victimCondition && this.victimCondition.injury" class="text-center">
    <template v-if="this.frontWounds.length || this.backWounds.length">
      <div class="row injuries-caption">
        <div class="col-xs-12 text-left">
          <strong>Legend</strong>
        </div>

        <div class="col-xs-12 text-left">
          <span class="injury-type" style="background-color:rgb(175, 36, 42)" /> <span>External injuries</span>
          <br />
          <span class="injury-type" style="background-color:rgb(35, 31, 32)" /> <span>Internal injuries</span>
          <br />
          <span class="injury-type" style="background-color:rgb(105, 33, 37)" /> <span>Both internal and external injuries</span>
        </div>
      </div>

      <div class="row details">
        <div class="col-xs-6"><label>Frontside</label></div>
        <div class="col-xs-6"><label>Backside</label></div>
      </div>
      <div class="row flex-row">
        <div class="col-xs-6">
          
          <img v-if="this.victimCondition.woundImage" class="img-thumbnail img-responsive"
               v-bind:src="'data:image/png;base64,' + this.victimCondition.woundImage" alt="Frontside injuries">
         
          <!-- <div v-if="this.frontWounds.length" class="gridpixel-front"></div> -->
          <div v-else class="caption">
            <span>No wounds</span>
          </div>
        </div>
        <div class="col-xs-6">
          
          <img v-if="this.victimCondition.backWoundImage" class="img-thumbnail img-responsive"
               v-bind:src="'data:image/png;base64,' + this.victimCondition.backWoundImage" alt="Backside injuries">
         
          <!-- <div v-if="this.backWounds.length" class="gridpixel-back"></div> -->
          <div v-else class="caption">
            <span>No wounds</span>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="text-center">Victim injured - no wounds specified</div>
  </div>
  <div v-else class="text-center">Victim not injured</div>
</template>

<script>
  import _ from 'lodash'
  import GridPaint from 'gridpaint'

  export default {
    props: ['victimCondition'],
    data () {
      var woundLocations = this.victimCondition ? this.victimCondition.woundLocations : null
      var backWoundLocations = this.victimCondition ? this.victimCondition.backWoundLocations : null
      return {
        frontWounds: _.compact(woundLocations),
        backWounds: _.compact(backWoundLocations)
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadFrontInjuries()
        this.loadBackInjuries()
      })
    },
    methods: {
      loadFrontInjuries () {
        const target = document.getElementsByClassName('gridpixel-front')[0]
        if (target) {
          this.loadGridInjuries(target, this.frontWounds)
        }
      },
      loadBackInjuries () {
        const target = document.getElementsByClassName('gridpixel-back')[0]
        if (target) {
          this.loadGridInjuries(target, this.backWounds)
        }
      },
      loadGridInjuries (targetDOMElement, injuries) {
        // TODO Edit mode only
        /*
        let disabledTick = [{'x': 0, 'y': 0}, {'x': 1, 'y': 0}, {'x': 1, 'y': 1}, {'x': 0, 'y': 1}, {'x': 5, 'y': 1}, {'x': 5, 'y': 0},
          {'x': 6, 'y': 0}, {'x': 6, 'y': 1}, {'x': 6, 'y': 4}, {'x': 5, 'y': 4}, {'x': 5, 'y': 5}, {'x': 6, 'y': 5}, {'x': 6, 'y': 6},
          {'x': 5, 'y': 6}, {'x': 6, 'y': 7}, {'x': 6, 'y': 8}, {'x': 6, 'y': 9}, {'x': 1, 'y': 4}, {'x': 0, 'y': 4}, {'x': 0, 'y': 5},
          {'x': 1, 'y': 5}, {'x': 1, 'y': 6}, {'x': 0, 'y': 6}, {'x': 0, 'y': 7}, {'x': 0, 'y': 8}, {'x': 0, 'y': 9}, {'x': 3, 'y': 8},
          {'x': 3, 'y': 9}]
        */

        const painter = new GridPaint({width: 7, height: 10, cellWidth: 20, cellHeight: 20})
        painter.background = false
        painter.grid = false
        painter.gridColour = '#F8AC3D'
        painter.palette = ['transparent', 'rgba(248, 172, 61, 0.8)']
        painter.colour = 1
        painter.tool = 'pencil'
        painter.applyTool(true)

        const canvasContainer = document.createElement('div')
        canvasContainer.appendChild(painter.dom)
        canvasContainer.style.marginBottom = '15px'
        canvasContainer.style.marginTop = '25px'
        canvasContainer.style.overflowX = 'auto'
        targetDOMElement.appendChild(canvasContainer)

        // Body background image
        const canvas = canvasContainer.getElementsByTagName('canvas')[0]
        canvas.style.background = 'url(/static/img/gugus.png) center center / contain no-repeat'
        // TODO Edit mode only
        // elt.getElementsByTagName('canvas')[0].style.borderRight = '1px solid #F8AC3D'
        // elt.getElementsByTagName('canvas')[0].style.borderBottom = '1px solid #F8AC3D'

        // Proportional canvas width/height ratio
        canvas.style.width = '100%'
        canvas.style.height = 'auto'

        // Keep canvas within its container : width/height ratio * height (incl. padding borders and margin)
        const containerStyle = window.getComputedStyle(canvasContainer)
        const availableHeight = canvasContainer.offsetHeight + parseInt(containerStyle.marginTop) + parseInt(containerStyle.marginBottom)
        canvas.style['max-width'] = `${(canvas.width / canvas.height) * availableHeight}px`

        injuries.forEach(function (w) {
          let xCoord = w.x
          let yCoord = w.y
          painter.painting[yCoord][xCoord] = 1
          painter.action()
        })

        // Add or remove color and location point
        // TODO Edit mode only
        /*
        elt.getElementsByTagName('canvas')[0].onclick = function () {
          let xCoord = painter.cursor.x
          let yCoord = painter.cursor.y
          let coordinates = {'x': xCoord, 'y': yCoord}
          let wl = woundLocation.findIndex(location => {
            return location.x === xCoord && location.y === yCoord
          })
          let dt = disabledTick.findIndex(tick => {
            return tick.x === xCoord && tick.y === yCoord
          })

          if (dt > -1) {
            painter.painting[yCoord][xCoord] = 0
          } else {
            if (wl > -1) {
              painter.painting[yCoord][xCoord] = 0
              woundLocation.splice(wl, 1)
            } else {
              woundLocation.push(coordinates)
            }
          }

          // _wl.setWoundLocation(woundLocation);
        }
        */

        painter.init()
        painter.drawing = false // 'Readonly' mode
      }
    }
  }
</script>

<style>
  .injuries-caption {
    margin-bottom: 1em;
  }

  .injuries-caption span {
    vertical-align: middle;
  }

  .injuries-caption span.injury-type {
    display: inline-block;
    width: 16px;
    height: 16px;
  }

  .gridpixel-front canvas, .gridpixel-back canvas {
    cursor: default !important;
  }
</style>



// WEBPACK FOOTER //
// Injuries.vue?df68ecee